import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { CorporationTaxRateService, NIThresholdsService, NIRatesService, SMESchemeRatesService, RDECSchemeRatesService, IntensiveSMERatesService } from '@services/rates';
import { RATES_SCHEME } from '../constants';
import Rate from '@rd-web-markets/shared/dist/rate/Rate';
export default function Rates() {
  const [corporationRates, setCorporationRates] = useState(null);
  const [niThresholds, setNIThresholds] = useState(null);
  const [niRates, setNIRates] = useState(null);
  const [SMESchemeRates, setSMESchemeRates] = useState(null);
  const [RDECSchemeRates, setRDECSchemeRates] = useState(null);
  const [IntensiveSMERates, setIntensiveSMERates] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    Promise.all([CorporationTaxRateService.all(), NIThresholdsService.all(), NIRatesService.all(), SMESchemeRatesService.all(), RDECSchemeRatesService.all(), IntensiveSMERatesService.all()]).then(result => {
      const [corporationRatesResult, niThresholdsResult, niRatesResult, SMESchemeRatesResult, RDECSchemeRatesResult, IntensiveSMERatesResult] = result;
      setCorporationRates(corporationRatesResult);
      setNIThresholds(niThresholdsResult);
      setNIRates(niRatesResult);
      setSMESchemeRates(SMESchemeRatesResult);
      setRDECSchemeRates(RDECSchemeRatesResult);
      setIntensiveSMERates(IntensiveSMERatesResult);
    }).catch(err => dispatch(handleError(err)));
  }, [dispatch]);
  const rateTitles = Object.keys(RATES_SCHEME);
  const rateData = [SMESchemeRates, IntensiveSMERates, RDECSchemeRates, corporationRates, niThresholds, niRates];
  const callbackData = [{
    service: SMESchemeRatesService,
    setter: setSMESchemeRates
  }, {
    service: IntensiveSMERatesService,
    setter: setIntensiveSMERates
  }, {
    service: RDECSchemeRatesService,
    setter: setRDECSchemeRates
  }, {
    service: CorporationTaxRateService,
    setter: setCorporationRates
  }, {
    service: NIThresholdsService,
    setter: setNIThresholds
  }, {
    service: NIRatesService,
    setter: setNIRates
  }];
  return /*#__PURE__*/React.createElement(Row, null, rateTitles.map((title, i) => {
    if (rateData[i]) {
      return /*#__PURE__*/React.createElement(Col, {
        key: "rates-".concat(title),
        lg: 4
      }, /*#__PURE__*/React.createElement(Rate, {
        title: title,
        rates: rateData[i],
        service: callbackData[i].service,
        onChange: () => {
          callbackData[i].service.all().then(res => {
            callbackData[i].setter(res);
          });
        }
      }));
    } else {
      return '';
    }
  }));
}